module.exports = {"width":1225,"height":545,"type":"png"}